<span class="d-flex flex-column" *ngIf="subscriptionType === subscriptionTypes.recurly">
  <p class="mb-0" *ngIf="pricePlan?.plan_code === paymentPlanCodes.Free">{{ pricePlan?.name }}</p>
  <p class="mb-0" *ngIf="pricePlan?.plan_code !== paymentPlanCodes.Free">
    {{ pricePlan?.name }}
    <span *ngIf="showPrice">{{ getPrice() | currency: 'USD' : 'symbol' : '1.0-0' }}</span>
  </p>
  <p class="sms-counter mb-0 text-center"><b>{{ usage?.total | number }}</b> / {{ usage?.limit | number }} SMS Used</p>
  <p class="sms-counter mb-0 text-center"><b>{{ usage?.parties | number }}</b> / {{ usage?.partiesLimit | number }} Parties Used</p>
  <p class="mb-0 tiny-text">Your SMS and parties usage will reset on {{ usage?.nextReset | trDateFormat: 'MMM D, YYYY': timezone  }}</p>
</span>

<span class="d-flex flex-column" *ngIf="subscriptionType === subscriptionTypes.offline">
  <p class="mb-0">Offline</p>
  <p class="sms-counter mb-0 text-center"><b>{{ usage?.total | number }}</b> / {{ usage?.limit | number }} SMS Used</p>
  <p class="sms-counter mb-0 text-center"><b>{{ usage?.parties | number }}</b> / {{ usage?.partiesLimit | number }} Parties Used</p>
  <p class="mb-0 tiny-text">Your SMS and parties usage will reset on {{ usage?.nextReset | trDateFormat: 'MMM D, YYYY': timezone  }}</p>
</span>
